// resources
import { txt } from '../../../locales/i18n';

export function getSessionStatus(record: Record<string, any>): string {
	const isPassed: boolean = new Date(record.sessionDateEnd) < new Date(Date.now());
	const isBooked: boolean = record.bookingStatus === 1;

	// cancelled by volunteer
	if (record.sessionStatus === -1) {
		return txt(`red-cross.session status.${record.sessionStatus}`);
	}

	// successful
	if (isPassed && isBooked) {
		return txt('red-cross.session status.ended');
	}

	// expired
	if (isPassed) {
		return txt('red-cross.session status.expired');
	}

	// active
	return txt(`red-cross.session status.${record.sessionStatus}`);
}

export function getBookingStatus(record: Record<string, any>): string {
	if (record.bookingStatus === -1) {
		return txt(`red-cross.booking status.${record.bookingStatus}`);
	}

	// assigned by volunteer
	if (Boolean(record.bookingAssigned) === true) {
		return txt('red-cross.booking status.assigned');
	}

	return txt(`red-cross.booking status.${record.bookingStatus}`);
}

export function getStatusRowClass(record: Record<string, any>): string {
	if (record.bookingStatus === -1) {
		return 'red-row-highlight';
	}

	if (record.sessionStatus === -1) {
		return 'orange-row-highlight';
	}

	return '';
}
